import React, { useEffect, useState } from 'react';
import moment from 'moment';
import FullWidthLayout from '../layouts/FullWidthLayout';
import Container from '../components/Container';
import './Home/HomePage.css';
import { useAppContext } from '../context/AppContext';
import * as Api from '../services/api';
import Typography from '@mui/joy/Typography';
import { Table } from '@mui/joy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { createTracker } from '../utils/log';


const AccountPage = () => {
  const { andee, sessionInfo } = useAppContext();
  const [tags, setTags] = useState([]);
  const trackEvent = createTracker(andee, sessionInfo);

  useEffect(() => {
    trackEvent('page_view', { page_name: 'account' });
    loadTags();
  }, []);

  const loadTags = async () => {
    try {
      const tags = await Api.getMyTags();
      setTags(tags || []);
      trackEvent('account', { status: 'tags_loaded' });
    } catch (e) {
      trackEvent('account', { status: 'tags_load_failed', error: e });
      console.error(e);
      // TODO: error handling
    }
  };

  return (
    <FullWidthLayout>
      <Container>
      <div style={{ marginBottom: 20 }}>
          <Typography level="h1">My Profile</Typography>
          <Typography level="body3" sx={{ mt: '-25px', pb: 2 }}>You can edit your info in the app.</Typography>
        </div>
        <div>
          <Typography level="h1">My Tags</Typography>
          <Typography level="body3" sx={{mt:'-25px', pb: 2}}>
            Hi, {andee.firstName} {andee.lastName}! Here are the &tags you own:
          </Typography>
          <Typography>
            <Table
              borderAxis="none"
              sx={{
                '--TableCell-borderColor': '#ffffff',
                '--TableCell-headBackground': '#e5e5e5',
              }}
              size="lg"
              stickyHeader
            >
              <thead>
                <tr>
                  <th>Tag</th>
                  <th>Purchase Price</th>
                  <th>Purchased on</th>
                  <th>NFT</th>
                </tr>
              </thead>
              <tbody>
                {!tags.length ? 'Loading tags...' : tags.map((tag, index) => (
                  <tr key={index}>
                    <td><strong>&{tag.tag}</strong></td>
                    <td>${Math.round(parseInt(tag.currentPrice) * 100) / 100} </td>
                    <td>
                      {moment(tag.createdTime).format('MMM Do, YYYY h:mm a')}
                    </td>
                    <td>
                      {!tag.xrplTokenId ? '-' : (
                        <a href={`https://livenet.xrpl.org/nft/${tag.xrplTokenId}`} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faExternalLink} />&nbsp;...{tag.xrplTokenId.substring(tag.xrplTokenId.length - 5)}</a>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Typography>
        </div>
      </Container>
    </FullWidthLayout >
  );
};

export default AccountPage;
